import { Room, PutRoom } from '../../interfaces/rooms';
import { rooms } from '../../api/rooms';

async function fetchRooms(): Promise<Room[]> {
	try {
		return await rooms.getRooms();
	} catch (error) {
		throw error;
	}
}

async function editRooms(id: number, room: PutRoom): Promise<Room> {
	try {
		return await rooms.editRoom(id, room);
	} catch (error) {
		throw error;
	}
}

export const roomService = {
	fetchRooms,
	editRooms,
};
